import * as React from "react";
const SvgSpaceBarOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M18 9v4H6V9H4v6h16V9h-2z" />
  </svg>
);
export default SvgSpaceBarOutlined;
